
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'projects/gtw-elements/src/environments/environment';
import { Dashboard } from './models/Dashboard';
import { DataSheet } from './models/DataSheet';
import { DashboardOptions } from './models/DashboardOptions';
import { GridEventService } from '../grid/services/grid-event.service';
import { JsonObjectFactoryService } from '../../global/services/json-object-factory.service';
import * as _ from 'lodash-es';
import { ExDashboardEventService } from './services/event.service';

export interface GetDashboardResponse {
  dashboard: DashboardOptions;
}

@Injectable({
  providedIn: 'root'
})
export class ExDashboardService {
  dashboardPool: Dashboard[] = [];



  constructor(private http: HttpClient,
    private jsonFactoryService: JsonObjectFactoryService,
    private eventService: ExDashboardEventService) {

  }
  createOrUpdateDashboard(name: string, id: string, dataSheets: DataSheet[], components: any[]): Dashboard {

    var dashboardIndex = this.dashboardPool.findIndex(function(item) { return item.id == id });
    var dash = new Dashboard(this.eventService, this.jsonFactoryService, name, id, dataSheets, components);
    if (dashboardIndex >= 0) {
      dash.dataLoaded = true;
      this.dashboardPool[dashboardIndex] = dash;
    } else {
      this.dashboardPool.push(dash);
    }

    return dash;

  };

  loadDashboardObservable(dashboardId: string, fresh = false) {
    const url = environment.base_url + '/getDashboardByKey?dashboard_id=' + dashboardId;
    return this.jsonFactoryService.shareGet(url, fresh, () =>
      this.http.get<GetDashboardResponse>(url),
    );
  }

  getDashboardById(id: string): Dashboard {
    return _.find(this.dashboardPool, { 'id': id })!;//asserting as dashboard key will be hardcoded
  }
}
